import { connect } from 'react-redux';
import { loadSlackUserData } from '../actions/slack';
import SlackSourceManager from '../components/slack_source_manager/slack_source_manager';

function mapStateToProps({ slack }) {
  const { team, channels } = slack;
  return {
    team,
    channels,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadSlackUserData: () => dispatch(loadSlackUserData()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SlackSourceManager);



// WEBPACK FOOTER //
// ./src/containers/slack_source_manager.js